// Anti-AdBlock Detection - DISABLED (too many false positives)
/*
const detectAdBlock = (): boolean => {
  const testAd = document.createElement('div');
  testAd.innerHTML = '&nbsp;';
  testAd.className = 'adsbox';
  testAd.style.position = 'absolute';
  testAd.style.left = '-9999px';
  document.body.appendChild(testAd);
  
  const isBlocked = testAd.offsetHeight === 0;
  document.body.removeChild(testAd);
  
  if (isBlocked) return true;
  
  if ((window as any).canRunAds === false) return true;
  if ((window as any).adBlockEnabled === true) return true;
  
  const adScripts = [
    'pagead2.googlesyndication.com',
    'adservice.google.com',
  ];
  
  const scripts = Array.from(document.scripts);
  const blockedScripts = adScripts.filter(adScript => 
    !scripts.some(script => script.src.includes(adScript))
  );
  
  return blockedScripts.length > 0;
};

const showAdBlockWarning = () => {
  const overlay = document.createElement('div');
  overlay.id = 'adblock-warning';
  overlay.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999998;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    text-align: center;
    padding: 2rem;
  `;
  
  overlay.innerHTML = `
    <div style="max-width: 500px; background: rgba(255,255,255,0.1); backdrop-filter: blur(10px); padding: 3rem; border-radius: 20px; box-shadow: 0 20px 60px rgba(0,0,0,0.3);">
      <div style="font-size: 4rem; margin-bottom: 1rem;">🚫</div>
      <h1 style="font-size: 2rem; margin-bottom: 1rem; font-weight: 700;">AdBlock Detected</h1>
      <p style="font-size: 1.1rem; opacity: 0.95; margin-bottom: 2rem; line-height: 1.6;">
        We noticed you're using an ad blocker. To support our free services and keep Flazu running, please disable your ad blocker for this site.
      </p>
      <div style="background: rgba(255,255,255,0.15); padding: 1.5rem; border-radius: 10px; margin-bottom: 2rem;">
        <p style="font-size: 0.95rem; margin: 0;">💡 Our ads are non-intrusive and help us provide free AI services to everyone.</p>
      </div>
      <button 
        onclick="location.reload()" 
        style="
          background: white;
          color: #667eea;
          border: none;
          padding: 1rem 2rem;
          font-size: 1rem;
          font-weight: 600;
          border-radius: 10px;
          cursor: pointer;
          transition: transform 0.2s;
          box-shadow: 0 4px 15px rgba(0,0,0,0.2);
        "
        onmouseover="this.style.transform='scale(1.05)'"
        onmouseout="this.style.transform='scale(1)'"
      >
        I've Disabled AdBlock
      </button>
    </div>
  `;
  
  document.body.appendChild(overlay);
};
*/

// Anti DevTools Protection
export const initProtection = () => {
  // let isDevToolsOpen = false;

  let warningShown = false;
  // let originalContent = '';

  const handleDevToolsOpen = () => {
    if (warningShown) return;
    warningShown = true;
    
    // Create overlay using DOM methods (safe from XSS)
    const overlay = document.createElement('div');
    overlay.id = 'devtools-warning';
    overlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 999999;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
      background: rgba(0, 0, 0, 0.95);
      color: white;
      text-align: center;
      padding: 2rem;
    `;
    
    // Icon
    const icon = document.createElement('div');
    icon.textContent = '⚠️';
    icon.style.cssText = 'font-size: 4rem; margin-bottom: 1rem;';
    
    // Title
    const title = document.createElement('h1');
    title.textContent = 'Debugging Tools Detected';
    title.style.cssText = 'font-size: 2rem; margin-bottom: 1rem; font-weight: 700;';
    
    // Description
    const description = document.createElement('p');
    description.textContent = 'Developer tools or HTTP debugger detected. Please close all debugging tools to continue.';
    description.style.cssText = 'font-size: 1.1rem; opacity: 0.95; max-width: 500px; margin-bottom: 2rem;';
    
    // Loading spinner
    const spinner = document.createElement('div');
    spinner.className = 'loading';
    spinner.style.cssText = `
      width: 40px;
      height: 40px;
      border: 4px solid rgba(255,255,255,0.3);
      border-top-color: white;
      border-radius: 50%;
      animation: spin 0.8s linear infinite;
    `;
    
    // Add spinner animation
    const style = document.createElement('style');
    style.textContent = '@keyframes spin { to { transform: rotate(360deg); } }';
    
    overlay.appendChild(icon);
    overlay.appendChild(title);
    overlay.appendChild(description);
    overlay.appendChild(spinner);
    overlay.appendChild(style);
    
    document.body.appendChild(overlay);
  };

  const handleDevToolsClosed = () => {
    if (!warningShown) return;
    warningShown = false;
    
    // Remove warning overlay
    const overlay = document.getElementById('devtools-warning');
    if (overlay) {
      overlay.remove();
    }
  };
  // Disable right click
  document.addEventListener('contextmenu', (e) => {
    e.preventDefault();
    return false;
  });

  // Disable F12, Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+U
  document.addEventListener('keydown', (e) => {
    if (
      e.keyCode === 123 || // F12
      (e.ctrlKey && e.shiftKey && e.keyCode === 73) || // Ctrl+Shift+I
      (e.ctrlKey && e.shiftKey && e.keyCode === 74) || // Ctrl+Shift+J
      (e.ctrlKey && e.keyCode === 85) || // Ctrl+U
      (e.ctrlKey && e.shiftKey && e.keyCode === 67) // Ctrl+Shift+C
    ) {
      e.preventDefault();
      return false;
    }
  });

  // Detect if mobile device
  const isMobile = /iPhone|iPad|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  
  // Multiple DevTools Detection Methods
  let devtoolsOpen = false;
  let detectionCount = 0;
  const DETECTION_THRESHOLD = isMobile ? 5 : 3; // Higher threshold for mobile

  // Method 1: Size detection (DISABLED on mobile)
  const detectDevToolsBySize = () => {
    // Skip detection on mobile devices (too many false positives)
    if (isMobile) return false;
    
    const threshold = 200;
    const widthThreshold = window.outerWidth - window.innerWidth > threshold;
    const heightThreshold = window.outerHeight - window.innerHeight > threshold;
    return widthThreshold || heightThreshold;
  };

  // Method 2: Console detection (commented out - not used)
  /*
  const detectDevToolsByConsole = () => {
    const element = new Image();
    let devtoolsDetected = false;
    Object.defineProperty(element, 'id', {
      get: function() {
        devtoolsDetected = true;
        throw new Error('DevTools detected');
      }
    });
    console.log(element);
    return devtoolsDetected;
  };
  */

  // Method 3: Debugger detection (commented out - not used)
  /*
  const detectDevToolsByDebugger = () => {
    const start = performance.now();
    debugger;
    const end = performance.now();
    return end - start > 100; // If debugger paused, time difference will be large
  };
  */

  // Method 4: toString detection (commented out - not used)
  /*
  const detectDevToolsByToString = () => {
    let detected = false;
    const div = document.createElement('div');
    Object.defineProperty(div, 'id', {
      get: function() {
        detected = true;
        return 'detected';
      }
    });
    console.log(div);
    return detected;
  };
  */

  // Method 5: Firebug detection
  const detectFirebug = () => {
    return !!(window as any).console?.firebug;
  };

  // Method 6: HTTP Debugger Detection (Proxy/MITM) - RELAXED for mobile
  let requestTimes: number[] = [];
  let baselineTime: number | null = null;
  
  const detectHTTPDebugger = async () => {
    // Skip on mobile (too many false positives due to slow networks)
    if (isMobile) return false;
    
    try {
      const start = performance.now();
      
      // Create a unique request to prevent caching
      const timestamp = Date.now();
      const randomParam = Math.random().toString(36).substring(7);
      
      // Tiny image request (1x1 pixel)
      const img = new Image();
      const imgPromise = new Promise((resolve) => {
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
        img.src = `/favicon.ico?_=${timestamp}_${randomParam}`;
      });
      
      await imgPromise;
      const end = performance.now();
      const requestTime = end - start;
      
      // Establish baseline on first few requests
      if (requestTimes.length < 3) {
        requestTimes.push(requestTime);
        if (requestTimes.length === 3) {
          baselineTime = requestTimes.reduce((a, b) => a + b, 0) / 3;
        }
        return false;
      }
      
      requestTimes.push(requestTime);
      if (requestTimes.length > 10) requestTimes.shift();
      
      // Calculate current average
      const recentAvg = requestTimes.slice(-5).reduce((a, b) => a + b, 0) / 5;
      
      // If current request is 5x slower than baseline (more lenient)
      if (baselineTime && recentAvg > baselineTime * 5 && recentAvg > 500) {
        console.warn('[Protection] HTTP Debugger suspected: Slow requests detected');
        return true;
      }
      
      // Check XHR timing patterns
      const perfEntries = performance.getEntriesByType('resource') as PerformanceResourceTiming[];
      const recentXHR = perfEntries.filter(e => 
        e.initiatorType === 'fetch' || e.initiatorType === 'xmlhttprequest'
      ).slice(-5);
      
      if (recentXHR.length > 0) {
        const avgXHRTime = recentXHR.reduce((sum, e) => sum + e.duration, 0) / recentXHR.length;
        // XHR through proxy is typically slower (increased threshold)
        if (avgXHRTime > 2000) {
          console.warn('[Protection] HTTP Debugger suspected: Slow XHR detected');
          return true;
        }
      }
      
      return false;
    } catch (e) {
      return false;
    }
  };

  // Method 7: TLS/SSL Interception Detection (RELAXED for mobile)
  const detectSSLInterception = () => {
    // Skip on mobile (SSL timing varies greatly)
    if (isMobile) return false;
    
    // Check if certificate is self-signed or modified
    const isHTTPS = window.location.protocol === 'https:';
    if (!isHTTPS) return false;
    
    // This would need actual certificate checking
    // For now, check performance API for certificate timing anomalies
    const navTiming = performance.getEntriesByType('navigation')[0] as any;
    if (navTiming && navTiming.secureConnectionStart) {
      const sslTime = navTiming.connectEnd - navTiming.secureConnectionStart;
      // SSL handshake with MITM proxy is usually slower (increased threshold)
      if (sslTime > 800) {
        return true;
      }
    }
    
    return false;
  };

  // Method 8: Resource Timing Detection (RELAXED for mobile)
  const detectResourceTampering = () => {
    // Skip on mobile (resources load slower)
    if (isMobile) return false;
    
    const resources = performance.getEntriesByType('resource');
    if (resources.length === 0) return false;
    
    let suspiciousCount = 0;
    
    resources.forEach((resource: any) => {
      // Check for unusual timing patterns (more lenient thresholds)
      const totalTime = resource.responseEnd - resource.startTime;
      const dnsTime = resource.domainLookupEnd - resource.domainLookupStart;
      
      // Proxy typically adds DNS lookup time (increased thresholds)
      if (dnsTime > 300 || totalTime > 5000) {
        suspiciousCount++;
      }
    });
    
    // If more than 60% of resources are suspicious (more lenient)
    return suspiciousCount > resources.length * 0.6;
  };

  // Method 9: Request Header Fingerprinting
  const detectModifiedHeaders = async () => {
    try {
      // Check if headers are being modified by proxy
      const response = await fetch(window.location.href, {
        method: 'HEAD',
        cache: 'no-store'
      }).catch(() => null);
      
      if (!response) return false;
      
      // Common proxy/debugger headers
      const proxyHeaders = [
        'x-forwarded-for',
        'x-forwarded-host',
        'x-forwarded-proto',
        'via',
        'x-proxy-id',
        'x-charles-proxy',
        'x-fiddler',
        'x-burp'
      ];
      
      for (const header of proxyHeaders) {
        if (response.headers.get(header)) {
          console.warn(`[Protection] Proxy header detected: ${header}`);
          return true;
        }
      }
      
      return false;
    } catch (e) {
      return false;
    }
  };

  // Method 10: Connection Speed Anomaly (DISABLED on mobile)
  const detectConnectionAnomaly = () => {
    // Skip on mobile (network varies greatly)
    if (isMobile) return false;
    
    const connection = (navigator as any).connection || (navigator as any).mozConnection || (navigator as any).webkitConnection;
    
    if (connection) {
      const effectiveType = connection.effectiveType;
      const downlink = connection.downlink;
      const rtt = connection.rtt;
      
      // If RTT is suspiciously high (increased threshold)
      if (rtt && rtt > 1000) {
        console.warn('[Protection] High RTT detected, possible proxy');
        return true;
      }
      
      // Check for speed/type mismatch (more lenient)
      if (effectiveType === '4g' && downlink < 0.5) {
        console.warn('[Protection] Speed anomaly detected');
        return true;
      }
    }
    
    return false;
  };

  // Method 11: Request Breakpoint Detection
  let lastCheckTime = Date.now();
  const detectBreakpoint = () => {
    const now = Date.now();
    const timeDiff = now - lastCheckTime;
    lastCheckTime = now;
    
    // If time difference is > 5 seconds, user might have paused on breakpoint
    if (timeDiff > 5000) {
      console.warn('[Protection] Breakpoint or pause detected');
      return true;
    }
    
    return false;
  };

  // Method 12: Performance Observer for Network Tampering
  if ('PerformanceObserver' in window) {
    try {
      const observer = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          if (entry.entryType === 'resource') {
            const resource = entry as PerformanceResourceTiming;
            // Check if request was intercepted (unusual timing)
            if (resource.duration > 3000) {
              console.warn('[Protection] Slow resource detected:', resource.name);
              detectionCount += 1;
            }
          }
        }
      });
      
      observer.observe({ entryTypes: ['resource'] });
    } catch (e) {
      // PerformanceObserver not supported
    }
  }

  // Combine all detection methods
  const detectDevTools = async () => {
    // Browser DevTools detection
    const devToolsSize = detectDevToolsBySize();
    const firebug = detectFirebug();
    const breakpoint = detectBreakpoint();
    
    // HTTP Debugger / Proxy detection
    const httpDebugger = await detectHTTPDebugger();
    const sslInterception = detectSSLInterception();
    const resourceTampering = detectResourceTampering();
    const modifiedHeaders = await detectModifiedHeaders();
    const connectionAnomaly = detectConnectionAnomaly();
    
    // Debug logging (only show if something detected)
    const debuggerDetected = httpDebugger || sslInterception || resourceTampering || modifiedHeaders || connectionAnomaly;
    if (debuggerDetected) {
      console.warn('[Protection] Debugging tool detected:', {
        httpDebugger,
        sslInterception,
        resourceTampering,
        modifiedHeaders,
        connectionAnomaly
      });
    }
    
    const detected = 
      devToolsSize ||
      firebug ||
      breakpoint ||
      httpDebugger ||
      sslInterception ||
      resourceTampering ||
      modifiedHeaders ||
      connectionAnomaly;

    if (detected) {
      detectionCount++;
      if (detectionCount >= DETECTION_THRESHOLD) {
        if (!devtoolsOpen) {
          devtoolsOpen = true;
          handleDevToolsOpen();
        }
      }
    } else {
      // Reset counter if not detected
      if (detectionCount > 0) {
        detectionCount = Math.max(0, detectionCount - 1);
      }
      if (devtoolsOpen) {
        devtoolsOpen = false;
        handleDevToolsClosed();
      }
    }
  };



  // Check every 2 seconds (async-friendly)
  const runDetection = async () => {
    await detectDevTools();
  };
  
  setInterval(runDetection, 2000);
  runDetection(); // Run immediately on load

  // ====================================
  // 🚫 ANTI-ADBLOCK DETECTION - DISABLED
  // ====================================
  // Too many false positives - disabled for now
  // Uncomment below to re-enable:
  
  /*
  if (!isMobile) {
    setTimeout(() => {
      if (detectAdBlock()) {
        console.warn('[Protection] AdBlock detected');
        showAdBlockWarning();
      }
    }, 3000);
    
    setInterval(() => {
      if (detectAdBlock() && !document.getElementById('adblock-warning')) {
        showAdBlockWarning();
      }
    }, 10000);
  }
  */

  // Window resize detection (DISABLED on mobile)
  if (!isMobile) {
    let lastOuterWidth = window.outerWidth;
    let lastOuterHeight = window.outerHeight;
    
    window.addEventListener('resize', () => {
      const widthDiff = Math.abs(window.outerWidth - lastOuterWidth);
      const heightDiff = Math.abs(window.outerHeight - lastOuterHeight);
      const innerWidthDiff = window.outerWidth - window.innerWidth;
      const innerHeightDiff = window.outerHeight - window.innerHeight;
      
      // If window size changed but inner size suggests devtools
      if ((widthDiff > 0 || heightDiff > 0) && (innerWidthDiff > 200 || innerHeightDiff > 200)) {
        handleDevToolsOpen();
      }
      
      lastOuterWidth = window.outerWidth;
      lastOuterHeight = window.outerHeight;
    });
  }

  // Detect orientation change
  window.addEventListener('orientationchange', () => {
    setTimeout(detectDevTools, 500);
  });

  // Light anti-debugger (less aggressive)
  // Commented out to reduce false positives
  // const antiDebug = () => {
  //   setInterval(() => {
  //     debugger;
  //   }, 3000);
  // };
  // antiDebug();

  // Disable select text
  document.addEventListener('selectstart', (e) => {
    e.preventDefault();
    return false;
  });

  // Disable copy
  document.addEventListener('copy', (e) => {
    e.preventDefault();
    return false;
  });

  // Light console clear (non-intrusive)
  // setInterval(() => {
  //   if (devtoolsOpen) {
  //     console.clear();
  //   }
  // }, 1000);

  // Don't override console to avoid conflicts
};